module.exports = __webpack_public_path__ + "static/dynaheir-mtg_clb-e0ae802edfe996445bc4bc0d29fc33fa.jpg";